import styled from "styled-components";

export const MusicHallEventDateFormStyled = styled.div`
  border-radius: 8px;
  padding: 24px;
  background-color: ${({ theme }) => theme.COLORS.WHITE_1};
  max-width: 420px;
  width: 100%;
  .f_tile {
    margin-bottom: 4px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }
  .f_sub_tile {
    margin-bottom: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_5};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  }
  .input_wrap {
    margin-bottom: 16px;
  }
  /* Inputs.Radio ปกติเรียง label กับตัวเลือกไว้แถวเดียวกัน ที่นี่บังคับให้เรียงลงมาเป็นรายการ */
  .date_wrap {
    .label {
      margin-bottom: 8px;
      color: ${({ theme }) => theme.COLORS.BLACK_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .radio_input_item {
      margin-bottom: 8px;
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_3};
      padding: 12px 14px;
      &:last-child {
        margin-bottom: 0;
      }
      .group_show_radio {
        column-gap: 10px;
        .radio_input {
          flex-shrink: 0;
        }
        .radio_label {
          flex: 1;
          line-height: 1.4;
        }
      }
    }
  }

  .action_layout {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn_action_wrap {
      max-width: 120px;
      width: 100%;
    }
  }
`;
